import React, { useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ChecklistIcon from '@mui/icons-material/Checklist';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: 'rgba(255, 255, 255, 0.95)',
  borderRadius: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[10],
  },
}));

const GoodGovernanceAndEthicalPractices = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Box sx={{ mt: 10, pb: 10 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            textAlign: 'center',
            mb: 6,
            color: '#1E88E5',
          }}
        >
          Good Governance & Ethical Practices
        </Typography>

        <Grid container spacing={6}>
          {/* Good Governance */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <AdminPanelSettingsIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Good Governance
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Promoting good governance and accountability in public service delivery through:
                    <ul>
                      <li>Organizing evidence-based policy dialogues on governance quality and service delivery</li>
                      <li>Providing training programs for duty-bearers</li>
                      <li>Hosting awareness workshops for right-holders</li>
                      <li>Facilitating informed engagement of CSOs on governance issues</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>

          {/* Ethical Practices */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up" data-aos-delay="200">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <ChecklistIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Ethical Practices
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Enhancing ethical practices and accountability among NeCSOO members and other CSOs in Oromia:
                    <ul>
                      <li>Implementing a Code of Ethics for members</li>
                      <li>Establishing a NeCSOO Code of Ethics Implementation Committee</li>
                      <li>Facilitating the committee’s regular operation</li>
                      <li>Linking the committee’s work to the CSO regulatory body for mutual support</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default GoodGovernanceAndEthicalPractices;
